import { render, staticRenderFns } from "./labelIconPosition-editor.vue?vue&type=template&id=581d219c&scoped=true&"
import script from "./labelIconPosition-editor.vue?vue&type=script&lang=js&"
export * from "./labelIconPosition-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581d219c",
  null
  
)

export default component.exports